import { HTTP } from "@/api";

export default {
  getSubscriptionHistory({ commit }) {
    commit("isLoading", {
      key: "subscriptions history",
      status: true
    });
    HTTP.get("/subcriptions").then(res => {
      let data = res.data;
      if (data && data.success) {
        commit("getSubscriptionHistory", data.result);
        commit("subTotal", data.counter);
      }
      commit("isLoading", {
        key: "subscriptions history",
        status: false
      });
      return data.success;
    });
  },
  getSubscription({ commit }) {
    commit("isLoading", {
      key: "subscriptions",
      status: true
    });
    return HTTP.get("/sub")
      .then(res => {
        let data = res.data;
        if (data && data.success) {
          commit("getSubscription", data.result);
          commit("subCounter", data.counter);
        }
        return data.success;
      })
      .finally(() => {
        commit("isLoading", {
          key: "subscriptions",
          status: false
        });
      });
  },
  setSubscription({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      HTTP.post("/sub", data)
        .then(res => {
          let data = res.data;
          if (data && data.success) {
            dispatch("getSubscription");
            resolve(data.success);
          } else reject(data.error || "Subscription save failed!");
        })
        .catch(reject);
    });
  }
};
